import { toast } from "react-toastify";

export const handleError = (err) => {
  const errorMessage =
    err?.response?.data?.name ||
    (typeof err === "string" ? err : "Došlo je do greške. Pokušajte ponovo.");

  toast.error(errorMessage, { theme: "colored" });
};
